/** Подпись кнопки строкой: из текста кнопки, `aria-label` или `title` — первое, что строка. */
export const textLabelOf = (...candidates: unknown[]): string | undefined =>
    candidates.find((candidate): candidate is string => typeof candidate === 'string' && candidate.trim() !== '');

// «Удалить из БД» → «удалить из БД», но «SQL-запрос» и «БД» остаются как есть
const lowerFirst = (text: string) =>
    text.length > 1 && text[1] !== text[1].toUpperCase() ? text[0].toLowerCase() + text.slice(1) : text;

/**
 * Надпись на самой взведённой кнопке. Полный вопрос («Точно удалить из БД?») — в подсказке и имени кнопки: длинный
 * внутри растягивал бы её и в обычном виде, ширина кнопки рассчитана на обе надписи.
 */
export const ARMED_SHORT_TEXT = 'Точно?';

/** Вопрос взведённой кнопки: «Удалить» → «Точно удалить?». */
export const armedTextOf = (label?: string): string => (label ? `Точно ${lowerFirst(label.trim())}?` : ARMED_SHORT_TEXT);

/** Объявление скринридеру при взводе: «Нажмите ещё раз, чтобы удалить». */
export const pressAgainTextOf = (label?: string): string =>
    label ? `Нажмите ещё раз, чтобы ${lowerFirst(label.trim())}.` : 'Нажмите ещё раз для подтверждения.';
